interface ICheckbox {
  onChange?: (newVal: boolean) => void;
  checked?: boolean;
  default?: boolean | null;
  name?: string;
}
export default function Checkbox(props: ICheckbox) {
  return (
    <input
      name={props.name}
      defaultChecked={props.default ?? undefined}
      type="checkbox"
      checked={props.checked}
      className="w-5 h-5 rounded-md border-[2.5px] text-brij-Blue box-border border-brij-Grey focus:border-brij-DarkGrey focus:outline-none bg-brij-White focus:ring-0 cursor-pointer"
      style={{ outline: "none" }}
      onChange={(e) => props.onChange?.(e.target.checked)}
    />
  );
}
